module.exports = __webpack_public_path__ + "static/13-Competative-Analysis-Chart-a0d06fc850a3a59ea283a3654dd7f989.png";